/** Normalizes a date-ish value to an ISO string, collapsing absent and unparseable dates to "". */
export function toIsoString(value: Date | string | null | undefined): string {
  if (!value) return "";
  if (value instanceof Date && Number.isNaN(value.getTime())) return "";
  return value instanceof Date ? value.toISOString() : value;
}
